import is from 'typescript-styled-is'
import styled, { css, ITheme } from '../../../theme'

export const INPUT_HEIGHT = 42
export const INPUT_WIDTH = 367

const inputStyles = css`
  position: relative;
  width: 100%;
  max-width: 100%;
  height: ${({ smallReservation, size }: IInputProps) =>
    smallReservation ? (size ? 38 * size : 38) : size ? 42 * size : 42}px ${({
                                                                               autoSize,
                                                                             }: IInputProps) => (autoSize ? '' : '!important')};

  font-size: ${({ size }) => (size ? 13 * size : 13)}px;

  line-height: ${({ smallReservation, size }: IInputProps) =>
    smallReservation ? (size ? 38 * size : 38) : size ? 42 * size : 42}px;
  padding-left: ${({ size }) => (size ? 10 * size : 10)}px;

  border: 1px solid ${({ theme }: ITheme) => theme.colors.palette.lightGrey};
  border-radius: 4px;

  color: ${({ theme }: ITheme) => theme.colors.palette.darkGreyTwo};
  font-weight: 500;

  &::-webkit-input-placeholder,
  &::-moz-placeholder,
  &:-ms-input-placeholder,
  &:-moz-placeholder {
    color: ${(props: ITheme) => props.theme.colors.placeholder};
  }

  &:focus {
    outline: none;
  }
  &:disabled {
    background: #f5f5f5;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance:textfield;

  ${is('readOnly')`
    cursor: pointer
  `}

  ${is('selected')`
    border: 1px solid ${({ theme }: ITheme) => theme.colors.palette.emerald};
    &:focus {
      border: 1px solid ${({ theme }: ITheme) => theme.colors.palette.emerald};
    }
  `}

  ${is('isWithError')`
      margin-top: ${({ size }) => 17 * size}px;
    `}

  ${is('error')`
    border: 1px solid ${({ theme }: ITheme) => theme.colors.palette.reddish};
    &:focus {
      border: 1px solid ${({ theme }: ITheme) => theme.colors.palette.reddish};
    }
  `}

  ${is('warning')`
    border: 1px solid ${({ theme }: ITheme) => theme.colors.palette.tangerine};
    &:focus {
      border: 1px solid ${({ theme }: ITheme) =>
    theme.colors.palette.tangerine};
    }
  `};
`

const Input = styled.input<IInputProps>`
  ${inputStyles}
`

export default Input
export { inputStyles }

export interface IInputProps {
  selected?: boolean
  error?: boolean
  warning?: boolean
  smallReservation?: boolean
  withAfterIcon?: boolean
  autoSize?: boolean
  size?: number
  isWithError?: boolean
  withoutPicker?: boolean
  readOnly?: boolean
}
